import React from "react";
import { Row, Col } from "react-bootstrap";
import Profile from "../components/User/Profile";

const MyProfile = () => {
  return (
    <>
      <Row className="justify-content-center">
        <Col lg={8} md={12}>
          <Profile />
        </Col>
      </Row>
    </>
  );
};

export default MyProfile;
